import {Injectable} from '@angular/core';
import {take} from 'rxjs/operators';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import {UserStore} from '@stores/user.store';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {NEVER, Observable, of} from 'rxjs';

/**
 * TODO I think this class is currently only useful for some obscure feature
 * nobody knows anything about, but if you remove it will break it.
 * Licenses are processed by the entry message processor
 */
@Injectable()
export class LicenseMessageProcessor implements WebsocketMessageProcessor {
  constructor(private userStore: UserStore) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (msg.int === APIM.EventIntent.UserUpdated) {
      params.wsAPI.result(msg);
      this.userStore.refreshAttributes().pipe(take(1)).subscribe();
      return of(true);
    }
    return NEVER;
  }
}
